export default __webpack_public_path__ + "static/speaker1-f90f48bd85b2ab2602d1059b2d365b98.jpg";